import { useEffect, useRef, useState } from 'react'
import CardCinza from './CardCinza'
import Container from './container'
import SvgLogoProjectiva from './svg-projectiva'
import SvgSeta from './svg-seta'

export default function Transformacoes() {
  const [projectsCount, setProjectsCount] = useState(0)
  const [solutionsCount, setSolutionsCount] = useState(0)
  const [collaboratorsCount, setCollaboratorsCount] = useState(0)
  const sectionRef = useRef(null)
  const animationTriggered = useRef(false)

  const targetCounts = {
    projects: 2000,
    solutions: 200,
    collaborators: 97,
  }

  const startCountAnimation = () => {
    if (animationTriggered.current) return

    animationTriggered.current = true

    const duration = 2000 // 2 seconds for the animation
    const framesPerSecond = 60
    const totalFrames = (duration / 1000) * framesPerSecond

    let frame = 0

    const interval = setInterval(() => {
      frame++
      const progress = frame / totalFrames

      if (progress >= 1) {
        setProjectsCount(targetCounts.projects)
        setSolutionsCount(targetCounts.solutions)
        setCollaboratorsCount(targetCounts.collaborators)
        clearInterval(interval)
        return
      }

      // Easing function for smoother animation
      const easeOutQuad = t => t * (2 - t)
      const easedProgress = easeOutQuad(progress)

      setProjectsCount(Math.round(easedProgress * targetCounts.projects))
      setSolutionsCount(Math.round(easedProgress * targetCounts.solutions))
      setCollaboratorsCount(
        Math.round(easedProgress * targetCounts.collaborators),
      )
    }, 1000 / framesPerSecond)
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        const [entry] = entries
        if (entry.isIntersecting) {
          startCountAnimation()
        }
      },
      { threshold: 0.2 },
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current)
      }
    }
  }, [])

  return (
    <section
      className="bg-[#040116] text-white py-10 lg:py-28"
      ref={sectionRef}
    >
      <Container className="flex flex-col gap-3.5 lg:gap-x-3.5 lg:flex-row">
        <div className="grid grid-cols-2 md:flex gap-x-3.5">
          <div className="space-y-3.5">
            <CardCinza className="p-0 relative h-28 md:h-[165px] w-full">
              <div className="absolute -top-2 -translate-x-1/2 left-1/2">
                <SvgSeta className="h-28" />
              </div>
            </CardCinza>
            <CardCinza className="h-fit md:h-[165px] w-full flex items-center justify-center p-6 md:p-8">
              <div className="space-y-2">
                <span className="block font-medium text-4xl md:text-5xl xl:text-[55px] text-[#C090F2] text-shadow-rosa">
                  +{collaboratorsCount}
                </span>
                <p className="font-semibold uppercase text-xs md:text-base">
                  DE colaboradores
                </p>
              </div>
            </CardCinza>
          </div>
          <CardCinza className="md:h-[344px] flex flex-col justify-end w-full p-6 md:p-8">
            <div className="space-y-8">
              <span className="block font-medium text-4xl md:text-5xl xl:text-[55px] text-[#C090F2] text-shadow-rosa">
                +{solutionsCount}
              </span>
              <p className="font-semibold text-xs md:text-base">
                SOLUÇÕES <br /> DISPONÍVEIS PARA <br /> IMPULSIONAR SEUS <br />
                NEGÓCIOS
              </p>
            </div>
          </CardCinza>
        </div>
        <div className="space-y-3.5">
          <div className="grid grid-cols-2 md:flex gap-x-3.5">
            <CardCinza className="h-[165px] flex items-center justify-center w-full">
              <SvgLogoProjectiva />
            </CardCinza>
            <CardCinza className="h-[165px] flex flex-col justify-between w-full">
              <span className="block font-medium text-4xl md:text-5xl xl:text-[55px] text-[#C090F2] text-shadow-rosa">
                +{projectsCount}
              </span>
              <p className="font-semibold text-xs md:text-base">
                DE PROJETOS DESENVOLVIDOS
              </p>
            </CardCinza>
          </div>
          <CardCinza className="md:h-[165px] w-full">
            <div className="space-y-2">
              <span className="block font-medium text-xl text-[#C090F2] text-shadow-rosa">
                SEGMENTOS ATENDIDOS
              </span>
              <p className="text-[#E0DADA] uppercase text-xs md:text-base">
                Financeiro | Agronegócios | Saúde | Telecom utilities |
                cooperativo | varejo
              </p>
            </div>
          </CardCinza>
        </div>
      </Container>
    </section>
  )
}
